"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.servicesUISchemaMapper = servicesUISchemaMapper;
function makeServiceUISchema(key) {
    return {
        type: "Control",
        scope: `#/properties/services/properties/${key}`,
        options: {
            format: "radio",
        },
    };
}
function makeServicesUISchema(services, withFrequency) {
    const groupedServices = [];
    for (let i = 0; i < services.length; i++) {
        const service = services[i];
        groupedServices.push(makeServiceUISchema(service.shortHand));
        if (withFrequency && withFrequency.includes(service.shortHand)) {
            const serviceKey = service.shortHand;
            if (withFrequency.includes(serviceKey)) {
                groupedServices.push({
                    type: "Control",
                    scope: `#/properties/services/properties/${serviceKey.toLowerCase()}Frequency`,
                    rule: {
                        effect: "SHOW",
                        condition: {
                            scope: `#/properties/services/properties/${serviceKey}`,
                            schema: {
                                const: "1",
                            },
                        },
                    },
                });
            }
        }
    }
    return groupedServices;
}
function servicesUISchemaMapper(template, services, serviceFrequencies) {
    const serviceUiSchema = {
        type: "Group",
        label: "Services",
        elements: makeServicesUISchema(services, serviceFrequencies),
    };
    const existingIndex = template.uiSchema.elements.findIndex((element) => element.label === "Services");
    if (existingIndex !== -1) {
        template.uiSchema.elements.splice(existingIndex, 1);
    }
    template.uiSchema.elements.splice(template.uiSchema.elements.length - 1, 0, serviceUiSchema);
    return template;
}
